import { useCases } from '@/mocks/homepage';

export default function UseCasesSection() {
  return (
    <section id="use-cases" className="w-full px-6 md:px-10 py-20 md:py-28 bg-background-100/60">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full mb-4">
            使用场景
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            适用于各行各业的内容协作场景
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            无论您的团队属于哪个行业，一起草都能提供量身定制的协作体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {useCases.map((useCase, index) => (
            <div
              key={index}
              className="p-6 md:p-8 rounded-lg bg-background-50 hover:shadow-sm transition-all duration-300 border border-background-200/60"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-5">
                <i className={`${useCase.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">{useCase.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{useCase.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}